
// 中药库存预警 接口相关的函数
import request from "@/untils/request.js"

/**
 * 
 *  post
 *  
 */

// 新增库存预警-保存
export const tralert = (data) => {
    return request.post("/outpatient/tcmAlert", data )
}

/**
 * 
 * put
 *  
 */


/**
 * 
 * get 
 *  
 */

// 库存预警列表
export const tralertList = (params) => {
    return request.get("/outpatient/tcmAlert/list", {params} )
}
// 设置库存预警数量列表
export const tralertPages = (params) => {
    return request.get("/outpatient/tcmAlert/pages", { params } )
}

/*
 * 
 * DELETE 
 *   
 */   

// 暴露
export default{
	tralertList,tralertPages,
	tralert
}